<template>
  <div class="card-wrapper">
    <div class="answer-card decision-card" :class="device">
      <div class="card-image" :style="{'background-image': 'url('+ option.image_url + ')'}" @click="$emit('nextStep')">
        <div class="label" v-text="option.label"></div>
        <div class="select-btn btn success">
          {{ $t('global.button.select') }}
        </div>
        <div class="overlay" :class="getActiveTheme"></div>
      </div>

      <div class="card-description" v-if="device !== 'mobile'">
        <p class="description" v-html="option.description"></p>
      </div>

      <div class="card-description" :class="device" v-else-if="device === 'mobile'">
        <div class="extend-description">
          <transition name="slide">
            <p class="description"
               v-if="extended"
               :class="{extended: extended}"
               v-html="option.description"
            ></p>
          </transition>

          <div class="extendable" v-if="!extended" @click="extended = true">
            <EInfoIcon/>
            <span>{{ $t('global.word.explanation') }}</span>
              <img v-if="checkIfThemeIsActive(availableThemes.Kabel24)" class="chevron" :class="getActiveTheme" :src="publicImage('themes/kabel24/chevron-down-primary.svg')">
              <img v-else class="chevron" :src="publicImage('themes/elektramat/arrow-blue-left.svg')">
          </div>

          <div class="extendable"
               :class="{extended: extended}"
               v-else-if="extended"
               @click="extended = false"
          >
            <EInfoIcon/>
            <span>{{ $t('global.word.close_explanation') }}</span>
              <img v-if="checkIfThemeIsActive(availableThemes.Kabel24)" class="chevron" :class="getActiveTheme" :src="publicImage('themes/kabel24/chevron-down-primary.svg')">
              <img v-else class="chevron" :src="publicImage('themes/elektramat/arrow-blue-left.svg')">
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import EInfoIcon from "@/components/library/EInfoIcon";
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'CardChoice',
  components: {EInfoIcon},
  data() {
    return {
      extended: false,
    };
  },

  computed: {
    ...mapGetters({
      checkIfThemeIsActive: 'theme/checkIfThemeIsActive',
      getActiveTheme: 'theme/getActiveTheme',
      availableThemes: 'theme/getAvailableThemes'
    }),
  },
  methods: {
    ...mapActions('preference', [
      'goBackOneStep',
    ]),
    goStepBack() {
      this.goBackOneStep();
    },
  },

  props: {
    option: {
      type: Object,
      required: true,
    },
    device: {
      type: String,
    },
  },
};
</script>

<style scoped lang="scss">
.decision-card {
  background-color: white;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);
  transition: all ease-out 0.2s;
  position: relative;
  overflow: hidden;
  will-change: transform;

  &.mobile {
    min-height: unset;
  }

  &:hover {
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.15);
  }

  .card-image {
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: all ease-out 0.2s;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    height: 203px;
    position: relative;
    overflow: hidden;
    cursor: pointer;

    @media only screen and (max-width: 576px) {
      height: 180px;
    }

    .select-btn {
      z-index: 1;
      margin-top: 10px;
      align-self: flex-start;
      font-weight: var(--configurator-font-weight-bold);

      @media only screen and (max-width: 576px) {
        align-self: flex-end;
      }
    }

    &:hover {
      .overlay {
        &.elektramat {
          transform: translate(100px, 100px) rotate(45deg);
        }

        &.kabel-24 {
          width: 500px;
          height: 500px;
          transform: translate(-8%, -25%);
        }
      }
    }

    .overlay {
      top: 0;
      bottom: 0;
      position: absolute;
      mix-blend-mode: multiply;
      transform-origin: top right;
      transition: all ease-out 0.3s;
      will-change: contents;

      &.elektramat {
        right: 0;
        background-color: var(--configurator-primary);
        transform: translate(-50px, 50px) rotate(45deg);
        border-radius: 42px;
        width: 2000px;
        height: 2000px;
      }

      &.kabel-24 {
        left: 0;
        background-color: var(--configurator-primary);
        transform: translate(-15%, -25%);
        border-radius: 50%;
        width: 364px;
        height: 364px;
      }
    }

    .label {
      z-index: 1;
      color: white;
      font-family: var(--configurator-font-heading);
      font-size: var(--configurator-decision-card-title-font-size);
      line-height: 1.1;
      max-width: 80%;
      text-shadow: 0 0 4px rgba(black, 0.4);
      margin-bottom: 8px;
      font-weight: var(--configurator-step-question-font-weight);
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-word;

      @media only screen and (max-width: 576px) {
        max-width: calc(100% - 70px);
        font-size: 22px;
      }
    }
  }

  .card-description {
    padding: 15px;
    display: flex;
    height: auto;

    &.mobile {
      min-height: 26px;
      padding: 0;

      .extend-description {
        font-size: 16px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .description {
          overflow: hidden;
          margin-bottom: 0;
          transition: max-height 0.3s ease;

          &.extended {
            padding: 14px 21px 0;
          }
        }

        .extendable {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 8px 0;
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }

          .chevron {
            width: 8px;
            transform: rotate(-90deg);
            transition: all ease-out 0.3s;

            &.kabel-24 {
              transform: rotate(0deg);
            }
          }

          .info-icon {
            position: relative;
            top: -2px;
          }

          &.extended {
            .chevron {
              transform: rotate(90deg);

              &.kabel-24 {
                transform: rotate(180deg);
              }
            }
          }

          span {
            font-size: var(--configurator-decision-card-text-font-size);
            font-family: var(--configurator-font);
            margin-left: 6px;
            margin-right: 15px;
          }
        }
      }
    }

    .description {
      color: black;
      font-size: var(--configurator-decision-card-text-font-size);
      margin-bottom: 0;

      ::v-deep {
        ul, ol {
          margin: 0 0 5px 0;
          padding: 0 0 0 25px;
        }
      }
    }
  }
}

.slide-enter-active,
.slide-leave-active {
  max-height: 300px;
}

.slide-enter,
.slide-leave-to {
  max-height: 0;
}
</style>
